import { apiClient } from './api';

function unwrapData<T>(
  res: { success: boolean; data?: T; message?: string; error?: string },
  fallbackMsg: string,
): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export const headerService = {
  async list(): Promise<Record<string, unknown>[]> {
    const res = await apiClient.get<Record<string, unknown>[]>('/admin/headers');
    return unwrapData(res, 'خطا در دریافت هدر سایت');
  },
  async create(data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.post<Record<string, unknown>>('/admin/headers', data);
    return unwrapData(res, 'ایجاد آیتم هدر ناموفق بود');
  },
  async update(id: string, data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.put<Record<string, unknown>>(`/admin/headers/${id}`, data);
    return unwrapData(res, 'ویرایش آیتم هدر ناموفق بود');
  },
  async remove(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/headers/${id}`);
    if (!res.success) throw new Error(res.message || 'حذف آیتم هدر ناموفق بود');
  },
};
